import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store.type';

interface UseTrialFormSubmissionProps {
    contactType: 'phone' | 'email';
    onSend: (contacts: string[]) => void;
    onClose: () => void;
}

export const useTrialFormSubmission = ({contactType, onSend, onClose}: UseTrialFormSubmissionProps) => {
    const phone = useSelector((s: RootState) => s.user.phone);
    const email = useSelector((s: RootState) => s.user.email);
    const onSubmit = useCallback((values) => {
        const validContacts = values.contacts?.filter(contact => contact?.trim() !== '');
        if(validContacts?.length > 0) {
            onSend(validContacts);
            onClose();
        }
    }, [onSend, onClose]);

    const handleAddContact = (arrayHelpers) => {
        arrayHelpers.push('');
    };
    const initialValues = contactType === 'email' ? {contacts: [email || '']} : {contacts: [phone || '']}; 
    return {
        initialValues,
        onSubmit,
        handleAddContact
    };
};
